export default "__VITE_ASSET__Dm1lAhMn__"